export default "__VITE_ASSET__DfOcIgDG__"